// components/PrivacyPolicy.js


import React from 'react';
import styles from './Privacy.module.css';

const PrivacyPolicy = () => {
  return (
    <section className={styles['privacy-section']}>
      <div className={styles['container']}>
        <h2 className={styles['heading']}>Privacy Policy</h2>
        <p className={styles['paragraph']}>
          Your privacy is important to us. This Privacy Policy outlines how MetalZulu collects, uses, and protects your information.
        </p>

        <h3 className={styles['subheading']}>1. Information We Collect</h3>
        <p className={styles['paragraph']}>
          We may collect personal information such as your name, email address, contact details, and usage data when you use our services.
        </p>

        <h3 className={styles['subheading']}>2. How We Use Your Information</h3>
        <p className={styles['paragraph']}>
          We use your data to provide, improve, and personalize our services. This includes sending updates, processing transactions, and supporting customer needs.
        </p>

        <h3 className={styles['subheading']}>3. Data Security</h3>
        <p className={styles['paragraph']}>
          We take reasonable measures to protect your information from unauthorized access or disclosure. However, no method is 100% secure.
        </p>

        <h3 className={styles['subheading']}>4. Sharing Information</h3>
        <p className={styles['paragraph']}>
          We do not sell your personal data. We may share it with trusted partners only for essential services such as payment processing or support.
        </p>

        <h3 className={styles['subheading']}>5. Cookies</h3>
        <p className={styles['paragraph']}>
          Our website may use cookies to improve your experience. You can choose to disable cookies in your browser settings.
        </p>

        <h3 className={styles['subheading']}>6. Changes to This Policy</h3>
        <p className={styles['paragraph']}>
          We may update our privacy policy from time to time. Changes will be posted on this page with the updated date.
        </p>

        <p className={styles['paragraph']}>
          If you have any questions about our privacy practices, feel free to contact us at support@metalzulu.com.
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
